import * as React from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import {
  Box,
} from '@mui/material'
import './App.css';

import PrivateRoute from './components/PrivateRoute';

import Chat from './pages/Chat'
import Presentation from './pages/Presentation';
import Visualization from './pages/Visualization';
import VisualizationDetail from './pages/VisualizationDetail';
import Forecast from './pages/Forecast';
import SQLGenerator from './pages/SQLGenerator';
import Settings from './pages/Settings';
import FinancialComparison from './pages/FinancialComparison';

import AdminPanel from './pages/admin/AdminPanel';
import Login from './pages/Login';
import Logout from './pages/Logout';

const App = () => {
  return (
    <Box className="w-full h-full">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/chat" element={<PrivateRoute role="USER"><Chat /></PrivateRoute>} />
          <Route path="/presentation" element={<PrivateRoute role="USER"><Presentation /></PrivateRoute>} />
          <Route path="/visualization/:id" element={<PrivateRoute role="USER"><VisualizationDetail /></PrivateRoute>} />
          <Route path="/visualization" element={<PrivateRoute role="USER"><Visualization /></PrivateRoute>} />
          <Route path="/forecast" element={<PrivateRoute role="USER"><Forecast /></PrivateRoute>} />
          <Route path="/sql-generator" element={<PrivateRoute role="USER"><SQLGenerator /></PrivateRoute>} />
          <Route path="/financial-comparison" element={<PrivateRoute role="USER"><FinancialComparison /></PrivateRoute>} />
          <Route path="/settings/*" element={<PrivateRoute role="USER"><Settings /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute role="ADMIN"><AdminPanel /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </Box>
  );
}

export default App;
